import {
    SET_REGION_DROP_DOWN_LIST,
    SET_REGIONS
} from "./RegionType";

const reducers = (state = [], action: any) => {
    if (action.type === SET_REGIONS) {
        return {
            ...state,
            regionDropDownList: action.regionDropDownList,
        };
    }
    else if (action.type === SET_REGION_DROP_DOWN_LIST) {
        return {
            ...state,
            regionDropDown: action.response,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}